import useSWR from 'swr'
import type { Fetcher } from 'swr'
import { client } from '~/api/client'
import { getMembersUserNameFollowingsV1, Schemas } from '~/api/gen'
import { FETCH_COUNT_PER_PAGE } from '../constants'

type SwrKey = [
  operation: 'getMembersUserNameFollowingsV1',
  userName: string,
  pageNumber: number,
]

const fetchGetMembersUserNameFollowingsV1: Fetcher<
  Schemas.get_members_user_name_followings_v1_response,
  SwrKey
> = async ([, userName, pageNumber]) => {
  const res = await getMembersUserNameFollowingsV1(client, {
    parameter: {
      user_name: userName,
      pageno: pageNumber,
      pagesize: FETCH_COUNT_PER_PAGE,
    },
  })
  if (res.type === 'error') {
    throw new Error(`Failed to fetch followings: ${res.error.message}`)
  }
  return res.data
}

export const useMemberFollowings = (
  userName: string,
  pageNumber: number
): Schemas.get_members_user_name_followings_v1_response | undefined => {
  const res = useSWR<
    Schemas.get_members_user_name_followings_v1_response,
    Error,
    SwrKey
  >(
    ['getMembersUserNameFollowingsV1', userName, pageNumber],
    fetchGetMembersUserNameFollowingsV1
  )
  return res.data
}
